<template>
  <div class="checkin__last-call--list" v-if="hdAvailableTo || mediaAvailableTo">
    <InfoMediaAvailableList :available-to="mediaAvailableTo" v-if="mediaAvailableTo"/>
    <InfoSdHdAvailableList :hd-available-to="hdAvailableTo" v-else-if="hdAvailableTo"/>
  </div>
</template>


<script>
import InfoMediaAvailableList from "@/domain/checkin/components/mediaInfo/InfoMediaAvailableList.vue";
import InfoSdHdAvailableList from "@/domain/checkin/components/mediaInfo/InfoSdHdAvailableList.vue";

export default {
  name: "InfosMediaList",
  components: {
    InfoSdHdAvailableList,
    InfoMediaAvailableList},
  props: {
    checkin: {
      type: Object,
      required: true
    }
  },
  computed: {
    hdAvailableTo() {
      return this.checkin.pica_service.hd_available_to
    },
    mediaAvailableTo() {
      return this.checkin.media_available_to
    },
  },

}
</script>

<style scoped>

</style>